import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

import { createVuetify } from "vuetify";

const WAIZMANN_BLUE = "#0f4c81";
const WAIZMANN_YELLOW = "#fecf0c";
const WAIZMANN_TURK = "#088A85";
const WAIZMANN_ORANGE = "#f6a800";
const WAIZMANN_GREEN = "#2e7d32";
const WAIZMANN_RED = "#b91c1c";
const WAIZMANN_INK = "#0f172a";

export default createVuetify({
  theme: {
    defaultTheme: "myTheme",
    themes: {
      myTheme: {
        dark: false,
        colors: {
          primary: WAIZMANN_BLUE,
          blue: WAIZMANN_BLUE,
          yellow: WAIZMANN_YELLOW,
          turk: WAIZMANN_TURK,
          orange: WAIZMANN_ORANGE,
          green: WAIZMANN_GREEN,
          red: WAIZMANN_RED,
          surface: "#ffffff",
          background: "#fafbfc",
          "on-primary": "#ffffff",
          "on-surface": WAIZMANN_INK,
        },
      },
      light: {
        colors: {
          primary: WAIZMANN_BLUE,
          blue: WAIZMANN_BLUE,
        },
      },
      dark: {
        colors: {
          primary: WAIZMANN_BLUE,
          blue: WAIZMANN_BLUE,
        },
      },
    },
  },
  defaults: {
    VBtn: {
      variant: "flat",
      rounded: "0",
      color: "primary",
    },
    VTextField: {
      variant: "outlined",
      density: "comfortable",
      hideDetails: "auto",
      rounded: "0",
      color: "primary",
    },
    VSelect: {
      variant: "outlined",
      density: "comfortable",
      hideDetails: "auto",
      rounded: "0",
      color: "primary",
    },
    VCheckbox: {
      density: "comfortable",
      hideDetails: "auto",
      color: "primary",
    },
    VRadio: {
      color: "primary",
    },
    VRadioGroup: {
      density: "comfortable",
      hideDetails: "auto",
      color: "primary",
    },
    VBtnToggle: {
      mandatory: true,
      divided: true,
      rounded: "0",
      color: "primary",
    },
    VAlert: {
      rounded: "0",
      variant: "tonal",
    },
    VCard: {
      rounded: "0",
      elevation: 0,
    },
    VDialog: {
      rounded: "0",
    },
  },
});
